<form class="c-form u-ost-lg" name="vm.form" #mainForm="ngForm" novalidate>
	<div class="c-modal c-modal--sm">
		<div mat-dialog-content class="c-modal__dialog">
			<div class="c-modal__header" *ngIf="!vm.success">
				<h1 class="c-text c-text--center c-text--heading c-text--xl">{{ 'Feedback.Title' | translate }}</h1>
			</div>
			<div class="c-modal__content u-no-pb" [ngClass]="{'u-no-pt': vm.success}" [ngSwitch]="vm.success">
				<!-- content: success -->
				<div *ngSwitchCase="true">
					<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/success.svg" alt="">
					<p class="c-text c-text--center c-text--heading c-text--xl">{{ 'Common.Thank_You' | translate }}</p>
					<p class="c-text c-text--center c-text--heading c-text--xl">{{ 'Feedback.Success' | translate }}</p>
					<div class="o-grid o-grid--center-h u-ost-xl">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
							<button id="feedbackModalCloseButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleModalClose()">{{ 'Common.Close' | translate }}</button>
						</div>
					</div>
				</div>
				<!-- content: input mode -->
				<div *ngSwitchDefault>
					<!-- content: input mode: overview -->
					<div class="c-card c-card--height-fit" style="box-shadow:none;">
						<div class="o-grid o-grid--center-h">
							<div class="o-grid__cell o-grid__cell--w-fixed">
								<div class="c-thumb">
									<div class="c-image c-image--bg c-image--round c-image--lg u-ost-lg u-osb-lg" [ngStyle]="{ 'background-image': 'url(' + (vm.subject.photoUrl) + ')' }"></div>
									<div class="c-thumb__extra c-thumb__extra--md" *ngIf="vm.isReporting">
										<button id="handleReportDestroyButton" type="button" class="c-badge c-badge--lg c-badge--s8" (click)="vm.handleReportDestroy()">
											<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/flag-alt.svg" class="c-image c-image--xs" />
											<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<p class="c-text c-text--center c-text--bold c-text--lg">{{ vm.subject.firstName }} {{ vm.subject.lastName }}</p>
						<p class="c-text c-text--center c-text--gray">{{ vm.occupation }}</p>
						<p class="c-text c-text--center u-ost-lg" *ngIf="!vm.isCommentRequired">{{ vm.info }}</p>
						
						<!-- content: input mode: rating -->
						<div class="o-grid o-grid--center-h" *ngIf="vm.isRatingDoctor && !vm.isCommentRequired">
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
								<input-rating [(model)]="vm.data.rating" [maxRating]="vm.maxRating" [isRequired]="true"></input-rating>
							</div>
						</div>
						<!-- content: input mode: flag -->
						<div class="o-grid o-grid--center-h" *ngIf="!vm.isRatingDoctor && !vm.isCommentRequired">
							<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
								<button id="handleReportInitButton" type="button" class="c-button c-button--tp u-no-p" (click)="vm.handleReportInit()">
									<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/flag.svg" class="c-image" aria-hidden="true" />
									<span class="u-sr-only">{{ 'Feedback.Report' | translate }}</span>
								</button>
							</div>
						</div>
						<!-- content: input mode: texts -->
						<div class="o-grid o-grid--center-h" *ngIf="vm.isRatingDoctor && vm.isCommentRequired">
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
								<p class="c-text">{{ 'Feedback.Your_Rating' | translate }}:</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
								<item-rating [model]="vm.data.rating" [maxRating]="vm.maxRating" [size]="'sm'"></item-rating>
							</div>
						</div>
						<p class="c-text c-text--center" *ngIf="vm.isCommentRequired && vm.isRatingDoctor" style="margin-top: 12px;">{{ 'Feedback.Comment_Doctor' | translate }}</p>
						<p class="c-text c-text--center" *ngIf="vm.isCommentRequired && !vm.isRatingDoctor">{{ 'Feedback.Comment_Patient' | translate }}</p>

						<!-- content: input mode: pseudonym -->
						<fieldset class="c-form__group u-no-mb" [ngClass]="{'c-form__group--error': vm.submitted && alias.invalid}" *ngIf="vm.isCommentRequired && vm.isRatingDoctor" style="margin-top: 10px;">
							<input type="text" class="c-form__input c-form__input--sm" id="alias" name="alias" [(ngModel)]="vm.data.alias"  (ngModelChange)="vm.onAliasChange($event)" #alias="ngModel" maxlength="50" [disabled]="vm.processing" />
							<p class="c-text c-text--sm c-text--gray c-text--left">{{ 'Feedback.Alias_Description' | translate }}</p>
						</fieldset>
						<!-- content: input mode: comment -->
						<fieldset class="c-form__group u-no-mb u-ost-lg" [ngClass]="{'c-form__group--error': vm.submitted && comment.invalid}" *ngIf="vm.isCommentRequired">
							<label for="comment" class="c-form__label u-sr-only">{{ 'Feedback.Comment' | translate }}</label>
							<textarea class="c-form__input" name="comment" id="comment" rows="5" [(ngModel)]="vm.data.comment" #comment="ngModel" maxlength="{{vm.maxCharacters}}" minlength="10" [disabled]="vm.processing"></textarea>
							<p class="c-text c-text--sm c-text--gray c-text--right u-osb-sm@up-to-md u-osr-sm@up-to-md" [ngClass]="{ 'c-text--s3': vm.submitted && comment?.errors?.maxlength }">{{ comment?.value?.length || 0 }} / {{ vm.maxCharacters }}</p>
						</fieldset>
						
						<!-- content: input mode: buttons -->
						<div class="o-grid o-grid--center-h u-ost-lg">
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p" *ngIf="vm.isRatingDoctor || vm.isCommentRequired">
								<button id="feedbackMainSubmitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleFormSubmit(mainForm)" [disabled]="vm.isRatingDoctor && !vm.data.rating">{{ 'Common.Send' | translate }}</button>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p" *ngIf="!vm.isCommentRequired && !vm.isRatingDoctor">
								<button id="feedbackMainCloseButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleModalClose()">{{ 'Common.Close' | translate }}</button>
							</div>
						</div>
						<!-- content: input mode: loader -->
						<loader-overlay *ngIf="vm.processing"></loader-overlay>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>